<template>
  <div class="container icon-box">
    <div
      class="icon-box-item"
      v-for="(item, index) in services"
      :key="index"
      @click="$router.push({ path: '/service', query: { ukey: item.ukey } })"
    >
      <img
        :src="item.tupian"
        style="width: 50px; height: 50px; margin-right: 12px"
      />
      <div class="icon-box-content" style="width: 200px">
        <h4 class="icon-box-title hang" style="text-align: left">
          {{ duoyuyan(item) }}
        </h4>
        <p
          class="text-default hang"
          style="text-align: left"
          v-html="duoyuyan(item, 'miaoshu')"
        ></p>
      </div>
    </div>
  </div>
</template>

<script>
import { getFuWu } from "@/api/fuwu";

export default {
  name: "IconBox",
  data() {
    return {
      services: [],
    };
  },
  mounted() {
    getFuWu().then((data) => {
      if (data.status === "SUCCESSED") this.services = data.data;
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon-box {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  overflow: scroll;
  border: 1px solid #eee;
  border-radius: 0.5rem;
  margin: 40px 0;
}
.icon-box-item {
  display: flex;
  align-items: center;
  margin: 40px 20px;
  flex-shrink: 0;
  cursor: pointer;
}
</style>
